// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".credit-method{gap:8px;height:100%;padding-top:12px}.credit-method .flex-row{padding:10px 20px;gap:16px}.credit-method .new-card{height:100%}.credit-method .new-card .square{padding:10px 20px 0}@media only screen and (max-width:1000px){.credit-method .new-card{height:-moz-fit-content;height:fit-content}}", ""]);
// Exports
module.exports = exports;
